<template>
  <div>
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Exclusão de mensagem</v-card-title>
        <v-card-text>Confirma a exclusão dessa mensagem?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" class="white--text" @click.native="dialogDelete = false">Cancela</v-btn>
          <v-btn
            color="success"
            class="white--text"
            @click.native="confirmaExclusao();dialogDelete = false"
          >Confirma</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-title>
            <span class="headline">{{alterar}} Mensagem</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field label="Título" v-model="mensagem.titulo" :rules="tituloRules" hint></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    outline
                    v-if="mostrarTexto"
                    :dont-fill-mask-blanks="false"
                    v-model="mensagem.texto"
                    label="Texto"
                    :rules="mensagemRules"
                    counter="130"
                    max
                    required
                    @keypress="keyhandler()"
                  ></v-textarea>
                </v-flex>
                <v-flex xs4>
                  <v-subheader>Destino:</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <v-select
                    :items="itemsCat"
                    v-model="mensagem.destino"
                    label="Selecione Destino"
                    :rules="destinoRules"
                    single-line
                    @change="selDestino"
                  ></v-select>
                </v-flex>
                <v-flex v-if="mostrarDestino" xs4>
                  <v-subheader>Para:</v-subheader>
                </v-flex>
                <v-flex v-if="mostrarDestino" xs8>
                  <v-select
                    :items="clientes"
                    item-text="nome"
                    autocomplete
                    item-value="cpf_cnpj"
                    v-model="mensagem.cpf"
                    :rules="selectAlvoRules"
                    label="Selecione um Cliente"
                    single-line
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-layout row>
                    <v-flex xs4>
                      <v-checkbox v-model="mensagem.tipo" label="Email" value="Email"></v-checkbox>
                    </v-flex>
                    <v-flex xs4>
                      <v-checkbox v-model="mensagem.tipo" label="WhatsApp" value="SMS"></v-checkbox>
                    </v-flex>
                    <v-flex xs4>
                      <v-checkbox v-model="mensagem.tipo" label="Notificação" value="Notifica"></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-flex xs12>
                    <v-alert
                      :value="checkTipo"
                      outline
                      color="error"
                      icon="warning"
                    >Selecione um tipo!</v-alert>
                  </v-flex>
                  <v-flex>
                    <v-layout row>
                      <v-flex xs6 md6 sm6 v-show="mostrarData">
                        <v-menu
                          ref="menu"
                          :close-on-content-click="false"
                          v-model="menu"
                          :nudge-right="170"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            v-model="dataFimFormatted"
                            label="Data de Envio"
                            readonly
                            persistent-hint
                            prepend-icon="event"
                            @blur="dataFim = parseDate(dataFimFormatted)"
                          ></v-text-field>
                          <v-date-picker
                            locale="pt-br"
                            v-model="dataFim"
                            no-title
                            :min="dataFim"
                            @input="menu = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs6 md6 sm6 v-show="mostraHora">
                        <v-select
                          v-model="mensagem.hora"
                          ref="hora"
                          :items="horas"
                          :rules="horaRules"
                          label="Hora"
                          prepend-icon="access_time"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-container>
            <small>*Campos requeridos</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn class="white--text" color="red darken-1" @click.native="dialog = false">Cancelar</v-btn>
            <v-btn
              class="white--text"
              color="green darken-1"
              :loading="btLoad"
              :disabled="btLoad"
              @click.native="mensagem.id==''? salvar():atualizar()"
            >Gravar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-container fluid fill-height>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card v-show="true" light class="Black--text" color="card">
            <v-card-title primary-title>
              <div class=".pa-1 text-md-left headline">Mensagem</div>
            </v-card-title>
            <v-card-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Pesquisar"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn class="white--text" @click="novo()" value="justify" color="sucesso">
                Nova
                <v-icon dark right>add</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :loading="false"
            rows-per-page-text="registros por página"
            no-data-text="Nenhum resultado encontrado!"
            no-results-text="Nenhum resultado encontrado!"
            class="elevation-1"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">{{ props.header.text }}</span>
                <span>{{ props.header.text }}</span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.titulo }}</td>
              <td class="text-xs-left">{{ props.item.texto.substring(0, 80) }}</td>
              <td class="text-xs-left">{{ props.item.destino }}</td>
              <td class="text-xs-rigth">{{ props.item.data }}</td>
              <td class="text-xs-rigth">{{ props.item.hora }}</td>
              <td class="text-xs-left">{{ props.item.status }}</td>
              <td class="text-xs-center">
                <v-btn
                  v-show="props.item.status =='Agendado'"
                  color="black"
                  @click="edit( props.item.id)"
                  flat
                  icon
                  small
                  tooltip="editar"
                >
                  <v-icon center>edit</v-icon>
                </v-btn>
                <v-btn
                  v-show="true"
                  color="red"
                  @click="deleteDialog( props.item.id);"
                  flat
                  icon
                  small
                >
                  <v-icon center>delete</v-icon>
                </v-btn>
              </td>
            </template>
            <template
              slot="pageText"
              slot-scope="props"
            >de{{ props.pageStart }} até {{ props.pageStop }} de {{ props.itemsLength }}</template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { HTTP } from "../services/http.axios";
import { formata } from "../services/format";
var moment = require("moment");

export default {
  mixins: [formata],

  data: () => ({
    mostrarTexto:true,
    selDelete: "",
    contadorCaracters: 700,
    selEdit: "",
    dataIn: moment().format("YYYY-MM-01"),
    search: "",
    checkTipo: false,
    valid: true,
    dialogDelete: false,
    alterar: "",
    mostrarDestino: false,
    mostrarData: true,
    mostraHora: true,
    clientes: [],
    btLoad: false,
    loader: null,
    horas: [
      "agora",
      "07:00",
      "08:00",
      "09:00",
      "10:00",
      "11:00",
      "12:00",
      "13:00",
      "14:00",
      "15:00",
      "16:00",
      "17:00",
      "18:00",
      "19:00",
      "20:00"
    ],
    itemsCat: [
      { text: "Todos" },
      { text: "Aniversariantes" },
      { text: "Direta" },
      { text: "Sem Cartão" }
    ],
    mensagem: {
      titulo: "",
      texto: "",
      data: moment().format("YYYY-MM-DD"),
      id: "",
      categoria: "Todos",
      cpf: "",
      hora: "",
      status: "A",
      tipo: []
    },

    tituloRules: [v => !!v || "Título é requerido"],
    selectAlvoRules: [v => !!v || "Selecione um cliente"],
    destinoRules: [v => !!v || "Selecione um Destino"],
    horaRules: [v => !!v || "Selecione uma hora"],
    mensagemRules: [v => !!v || "Texto da mensagem é requerida"],
    dialog: false,
    dataInFormatted: moment().format("01/MM/YYYY"),
    menu: false,
    menu2: false,
    time: null,
    dataFim: moment().format("YYYY-MM-DD"),
    dataFimFormatted: moment().format("DD/MM/YYYY"),
    // idFranquia: localStorage.getItem("tituloApp"),

    headers: [
      {
        text: "Título",
        sortable: true,
        align: "left",
        value: "titulo"
      },
      {
        text: "Mensagem",
        align: "left",
        value: "texto"
      },
      {
        text: "Destino",
        align: "left",
        value: "destino"
      },
      {
        text: "Data",
        align: "center",
        value: "data"
      },
      {
        text: "Hora",
        align: "center",
        value: "hora"
      },
      {
        text: "Status",
        align: "left  ",
        value: "status"
      },
      {
        text: "Ações",
        value: "acoes",
        align: "center",
        sortable: false
      }
    ],
    items: []
  }),
  mounted() {
    this.buscaMensagens();
    this.zeraCampos();
    this.buscaCliente();
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.dataFim);
    }
  },

  watch: {
    "mensagem.tipo"(val) {
      this.mostrarTexto = true
      var a = val.indexOf("SMS");
      
      if(a > -1) {
        this.mostrarTexto = false
      } 
      if (a >= 0 && this.mensagem.texto.length > 130) {
        //  alert("ok");

        this.mensagem.tipo.splice(a, 1);
        event.preventDefault();
      }
    },
    dataIn(val) {
      this.dataInFormatted = this.formatDate(this.dataIn);
      this.mensagem.data = this.dataIn;
    },
    dataFim(val) {
      this.dataFimFormatted = this.formatDate(this.dataFim);
      this.mensagem.data = this.parseDate(this.dataFimFormatted);
    }
  },

  methods: {
    selDestino(val) {
      if (val == "Direta") {
        this.mostrarDestino = true;
      } else {
        this.mostrarDestino = false;
      }
      if (val == "Aniversariantes") {
        this.mostrarData = false;
        this.mostraHora = true;
      } else {
        this.mostrarData = true;
      }
    },
    keyhandlerHora: function(event) {
      if (this.mensagem.hora.length == 2) {
        let hr = this.mensagem.hora.split(":");
        if (hr[0] > 20 || hr[0] < 7) {
          alert("Informe uma hora entre 7hs e 20hs");
          event.preventDefault();
          this.mensagem.hora = "";
        }
      }
    },
    verificaMinutos(event) {
      if (this.mensagem.hora.length == 4) {
        let hr = this.mensagem.hora.split(":");
        if (
          hr[1] == 10 ||
          hr[1] == 20 ||
          hr[1] == 30 ||
          hr[1] == 40 ||
          hr[1] == 50
        ) {
        } else {
          event.preventDefault();
          //alert("Informe minutos igual a 10,20,30,40,50");
          this.$refs.hora.focus();
        }
      }
    },
    keyhandler: function(event) {
      if (this.mensagem.texto.length > 129) {
        var a = this.mensagem.tipo.indexOf("SMS");

        if (a >= 0) {
          this.mensagem.tipo.splice(a, 1);
        }
      }
    },
    deleteDialog(id) {
      this.selDelete = id;
      this.dialogDelete = true;
    },
    confirmaExclusao() {
      HTTP.delete(`mensagem/` + this.selDelete).then(response => {
        this.buscaMensagens();
      });
    },
    edit(id) {
      return HTTP.get(`mensagem/` + id).then(response => {
        console.log(response.data);
        this.mensagem = response.data;
        this.mensagem.tipo = response.data.tipo.split(",");
        this.mensagem.data = this.parseDate(response.data.data);
        this.dataFim = response.data.data;
        this.dialog = true;
        this.alterar = "Alterar";
      });
    },
    buscaCliente() {
      return HTTP.get(`cliente/lista/`).then(response => {
        console.log(response.data);
        this.clientes = response.data;
      });
    },
    zeraCampos() {
      this.mensagem.titulo = "";
      this.mensagem.texto = "";
      this.mensagem.id = "";
      this.mensagem.hora = "";
      this.btLoad = false;
      (this.mensagem.data = moment().format("YYYY-MM-DD")),
        (this.mensagem.tipo = []);
      this.alterar = "";
    },
    atualizar() {
      if (this.mensagem.tipo.length == 0) {
        this.checkTipo = true;
        return false;
      } else {
        this.checkTipo = false;
      }
      if (this.mensagem.hora == "agora") {
        this.mensagem.status = "N";
      }
      this.mensagem.tipo = this.mensagem.tipo.join(",");

      if (this.$refs.form.validate()) {
        HTTP.put(`mensagem/` + this.mensagem.id, this.mensagem)
          .then(response => {
            console.log(response.data);

            setTimeout(() => this.buscaMensagens(), 1000);
            this.dialog = false;
          })
          .catch(e => {
            this.loadingResetSenha = false;
            if (!Array.isArray(e.response.data.errors)) {
              let itens = [];
              for (var prop in e.response.data.errors) {
                itens.push(e.response.data.errors[prop][0]);
              }
              this.textSnack = itens.join(" ");
              this.snackbar = true;
            } else {
              this.textSnack = e.response.data.errors;
              this.snackbar = true;
            }
          });
      }
    },
    salvar() {
      if (this.mensagem.tipo.length == 0) {
        this.checkTipo = true;
        return false;
      } else {
        this.checkTipo = false;
      }
      if (this.mensagem.hora == "agora") {
        this.mensagem.status = "N";
      }

      this.btLoad = true;

      if (this.$refs.form.validate()) {
        HTTP.post(`mensagem`, this.mensagem)
          .then(response => {
            console.log(response.data);

            setTimeout(() => this.buscaMensagens(), 1000);
            this.dialog = false;
            this.btLoad = false;
          })
          .catch(e => {
            this.btLoad = false;
            this.loadingResetSenha = false;
            if (!Array.isArray(e.response.data.errors)) {
              let itens = [];
              for (var prop in e.response.data.errors) {
                itens.push(e.response.data.errors[prop][0]);
              }
              this.textSnack = itens.join(" ");
              this.snackbar = true;
            } else {
              this.textSnack = e.response.data.errors;
              this.snackbar = true;
            }
          });
      }
      this.btLoad = false;
    },
    novo() {
      this.zeraCampos();
      this.dialog = true;
    },
    filtrar() {
      this.buscaExtratoCartao(this.dataIn, this.dataFim);
    },
    formata_moeda(val) {
      let val1 = val / 100;
      let valor = this.formatar_moeda(val1);
      return valor;
    },
    buscaMensagens(dataIn, dataFim) {
      this.loading = true;
      HTTP.get(
        //`mensagem/lista` + "/" + dataIn + "/" + dataFim
        `mensagem`
      ).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
        } else {
          //this.extrato =

          this.items = response.data;
          //this.mostraCartoes = true;
        }
        this.loading = false;
      });
    },

    //mudar para um mixed
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>

<style>
#container {
  margin-top: 115px;
}
</style>



// WEBPACK FOOTER //
// src/components/Mensagem.vue